import { defineMessages } from 'react-intl';

export const addReviewMessages = defineMessages({
  dialogTitle: {
    defaultMessage: 'Bewerte das Produkt',
    id: 'customerReviews.addReview.dialogTitle',
  },
  successNotification: {
    defaultMessage: 'Bewertung erfolgreich abgeschickt. Vielen Dank!',
    id: 'customerReviews.addReview.notification.success',
  },
  errorNotification: {
    defaultMessage: 'Bewertung konnte nicht abgeschickt werden!',
    id: 'customerReviews.addReview.notification.error',
  },
  successHint: {
    defaultMessage:
      'Alle Bewertungen werden geprüft. In 3-5 Werktagen wird deine Bewertung für alle Kunden angezeigt.',
    id: 'customerReviews.addReview.success.hint',
  },
});
